import * as React from 'react';
import { connect } from 'react-redux';
import * as _ from 'underscore';

import { bindActionCreators } from 'redux';
import { Messages } from '../../../codegen/Localize';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { BrowserTitleService } from '../../../commonInfra/services/BrowserTitleService';
import { requestSpaceContents } from '../../actions/spaces/RequestSpaceContentsActions';
import { SessionSiteSelectors } from '../../selectors/SessionInfoSelectors';
import { AppState } from '../../state/AppState';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '../../state/SpaceInfo';
import { MapDispatchToProps, MapStateToProps } from '../../utils/ConnectUtils';
import { RouterError } from '../RouterHelpers/RouterError';
import { ConnectedSpaceInfoProvider } from '../RouterHelpers/SpaceInfoProvider';
import { SpacesSiteUrls } from '../SpacesSiteUrls';
import { ConnectedRecommendationsSpace } from './ConnectedRecommendationsSpace';

export interface RecommendationsSpaceProviderOwnProps extends ReactDirectiveProps {
  readonly siteName: string;
  readonly urls: SpacesSiteUrls;
}

export interface RecommendationsSpaceProviderStateProps {
  readonly isVizRecommendationsEnabled: boolean;
}

export interface RecommendationsSpaceProviderDispatchProps {
  readonly requestSpaceContents: () => void;
}

export type RecommendationsSpaceProviderNonAngularProps = RecommendationsSpaceProviderOwnProps & RecommendationsSpaceProviderStateProps & RecommendationsSpaceProviderDispatchProps;
export type RecommendationsSpaceProviderProps = RecommendationsSpaceProviderNonAngularProps;

export class RecommendationsSpaceProviderComponent extends React.PureComponent<RecommendationsSpaceProviderProps> {

  public render() {
    if (this.props.isVizRecommendationsEnabled) {
      const spaceInfo: SpaceInfo = {
        item: SpaceItemForNonEntitySpace,
        spaceType: 'recommendations',
        subspaceName: undefined,
      };

      return (
        <ConnectedSpaceInfoProvider spaceInfo={spaceInfo}>
          <ConnectedRecommendationsSpace angularContext={this.props.angularContext}/>
        </ConnectedSpaceInfoProvider>
      );
    } else {
      return <RouterError errorType={'default'} urls={this.props.urls}/>;
    }
  }

  public componentDidMount() {
    if (this.props.isVizRecommendationsEnabled) {
      BrowserTitleService.setTitleWithPlaceEntityName({ placeEntityName: Messages.vizRecommendationsTitle() });
      this.props.requestSpaceContents();
    }
  }

  public componentDidUpdate(prevProps: RecommendationsSpaceProviderProps) {
    if (this.props.isVizRecommendationsEnabled &&
      !_.isUndefined(this.props.siteName) &&
      prevProps.siteName !== this.props.siteName) {
      this.props.requestSpaceContents();
    }
  }
}

const mapStateToProps: MapStateToProps<RecommendationsSpaceProviderStateProps> = (state: AppState) => ({
  isVizRecommendationsEnabled: SessionSiteSelectors.isVizRecommendationsEnabled(state)
});

const mapDispatchToProps: MapDispatchToProps<RecommendationsSpaceProviderDispatchProps> = (dispatch) => bindActionCreators({
  requestSpaceContents,
}, dispatch);

export const RecommendationsSpaceProvider: React.ComponentClass<RecommendationsSpaceProviderOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(RecommendationsSpaceProviderComponent);
